/**
 * @license BCP
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name upload
 * @description
 *
 * # upload
 *
 * The `upload` module provides upload files component.
 */

/**
 * @ngdoc factory
 * @name upload
 *
 */
angular.module("upload", [])
 /**
 * @ngdoc directive
 * @name fileOnSelect
 *
 * @description
 * Custom attribute which allow catch event of select file
 */
.directive("fileOnSelect", function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var onChangeHandler = scope.$eval(attrs.fileOnSelect);
        element.bind('change', onChangeHandler);
      }
    };
  });

})();
